import { ElementType, HTMLAttributes } from 'react'
import { cn } from '../../lib/cn.js'
import styles from './Container.module.css'

export interface ContainerProps extends HTMLAttributes<HTMLElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  padding?: boolean
  as?: ElementType
}

export function Container({
  size = 'lg',
  padding = true,
  as: Tag = 'div',
  className,
  ...props
}: ContainerProps) {
  return (
    <Tag
      className={cn(styles.root, styles[size], padding && styles.padded, className)}
      {...props}
    />
  )
}
